export const can = (permissions = [], permission) => {
  return permissions.includes(permission);
};

export const canAny = (permissions = [], required = []) => {
  return required.some((p) => permissions.includes(p));
};
